import { useSelector } from 'react-redux';
import { useGetOrganizationQuery } from '../api/organization/organizationApiSlice';
import { tenantSelector } from '../selector/authenticationSelector';
import { isSelfServiceTenant } from '../common/tenantStore';
import { resolveOrgOrUnitClassId } from '../utils/customerClassResolution';

/**
 * The customer class a booking inherits from the organisation (unit) it is
 * attributed to (#1810) — what "no override" resolves to once a booking has
 * an organisation. Null when it has none, or neither carries a class.
 *
 * Read with the same rule the backend prices by (`resolveOrgOrUnitClassId`,
 * pinned against both backend copies), so the class select can name the class
 * the price box is actually quoting instead of the system default.
 */
export const useAttributedClassId = (attribution: {
    organizationId: string | null;
    organizationUnitId: string | null;
}): string | null => {
    const tenant = useSelector(tenantSelector);
    const { data: organization } = useGetOrganizationQuery(
        { id: attribution.organizationId ?? '' },
        { skip: !isSelfServiceTenant(tenant) || !attribution.organizationId },
    );
    if (!attribution.organizationId || organization?.id !== attribution.organizationId) return null;
    const unit = organization.units.find((u) => u.id === attribution.organizationUnitId);
    return resolveOrgOrUnitClassId(organization.customerClassId, unit?.customerClassId);
};
